import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_RESPONSE_TIME } from './types';

import { responseTimeSuccess, responseTimeFailure } from './reducer';

const logger = new Logger('Saga:Dashboard:ResponseTime');

export function* getFundingSearchOverview() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.dashboard.lender_response_time'),
    );

    logger.info('Got response time data');
    yield put(responseTimeSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(responseTimeFailure(error));
  }
}

export default function* userSaga() {
  return yield all([takeLatest(REQUEST_RESPONSE_TIME, getFundingSearchOverview)]);
}
